import { SearchInput } from '@/components/search-input'

/** the name-search box shared by the directory and due-diligence toolbars.
 * the surrounding filter row differs per page, so only the input is shared.
 */
export function SupplierSearchInput({
  value,
  onChange
}: {
  value: string
  onChange: (value: string) => void
}) {
  return (
    <SearchInput
      value={value}
      onChange={onChange}
      placeholder='Search by name…'
      aria-label='Search suppliers by name'
      className='w-full sm:max-w-sm sm:flex-1'
    />
  )
}
